<div>
  @switch (fareTitle) {
    @case (ermFareTypes.MarineFare) {
      <div>
        <section class="container" (mouseleave)="tt1.close()">
          <div
            i18n-ngbTooltip
            rel="icon"
            type="image/x-icon"
            ngbTooltip="Marine fare"
            class="fare-icon ship-marine-icon"
            triggers="manual"
            #tt1="ngbTooltip"
            (mouseenter)="tt1.open()"
            (focus)="tt1.open()"
            (blur)="tt1.close()"
            tabindex="0"
          >
            <span class="visuallyhidden" i18n="@@marineFareTooltip">Marine Fare</span>
          </div>
        </section>
      </div>
    }
    @case (ermFareTypes.OffshoreFare) {
      <div>
        <section class="container" (mouseleave)="tt2.close()">
          <div
            i18n-ngbTooltip
            rel="icon"
            type="image/x-icon"
            ngbTooltip="Offshore Fare"
            class="fare-icon rig-offshore-icon"
            triggers="manual"
            #tt2="ngbTooltip"
            (mouseenter)="tt2.open()"
            (focus)="tt2.open()"
            (blur)="tt2.close()"
            tabindex="0"
          >
            <span class="visuallyhidden" i18n="@@offshoreTooltip">Offshore Fare</span>
          </div>
        </section>
      </div>
    }
    @case (ermFareTypes.AirFare) {
      <div>
        <section class="container" (mouseleave)="tt3.close()">
          <div
            i18n-ngbTooltip
            rel="icon"
            type="image/x-icon"
            ngbTooltip="Air Fare"
            class="fare-icon renewable-energy-icon"
            triggers="manual"
            #tt3="ngbTooltip"
            (mouseenter)="tt3.open()"
            (focus)="tt3.open()"
            (blur)="tt3.close()"
            tabindex="0"
          >
            <span class="visuallyhidden" i18n="@@airFareTooltip">Air Fare</span>
          </div>
        </section>
      </div>
    }
    @case (ermFareTypes.SeaFare) {
      <div>
        <section class="container" (mouseleave)="tt4.close()">
          <div
            i18n-ngbTooltip
            rel="icon"
            type="image/x-icon"
            ngbTooltip="Sea Fare"
            class="fare-icon renewable-energy-icon"
            triggers="manual"
            #tt4="ngbTooltip"
            (mouseenter)="tt4.open()"
            (focus)="tt4.open()"
            (blur)="tt4.close()"
            tabindex="0"
          >
            <span class="visuallyhidden" i18n="@@seaFareTooltip">Sea Fare</span>
          </div>
        </section>
      </div>
    }
    @default {
      <div>
        <section (mouseleave)="tt5.close()">
          <span
            ngbTooltip="Company Negotiated Rate"
            i18n-ngbTooltip
            triggers="manual"
            #tt5="ngbTooltip"
            (mouseenter)="tt5.open()"
            (focus)="tt5.open()"
            (blur)="tt5.close()"
            tabindex="0"
          >
            <i class="ico-star {{ getSpecialFareCode() }}" aria-hidden="true"></i>
            <span class="visuallyhidden" i18n="@@cnrTooltip">Company Negotiated Rate</span>
          </span>
        </section>
      </div>
    }
  }
</div>
